import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from '../services/storage.service';
import { environment } from '@environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private storageService = inject(StorageService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // If the request already has an Authorization header (e.g., itinerary client-credentials),
    // do not override it.
    if (req.headers.has('Authorization')) {
      return next.handle(req);
    }

    // Get the auth token directly from storage to avoid DI cycles
    const rawSessionToken = typeof window !== 'undefined' ? sessionStorage.getItem('access_token') : null;
    const rawLocalToken = typeof window !== 'undefined' ? localStorage.getItem('access_token') : null;
    const authToken =
      rawSessionToken
      ?? rawLocalToken
      ?? this.storageService.getSessionItem<string>('access_token')
      ?? this.storageService.getItem<string>('access_token');

    const isAuthApiRequest = req.url.startsWith(environment.userManagementApi.signUp)
      || req.url.startsWith(environment.userManagementApi.loginUser)
      || req.url.startsWith(environment.userManagementApi.resetPassword)
      || req.url.startsWith(environment.userManagementApi.codePass)
      || req.url.startsWith(environment.userManagementApi.updateCodePass);

    const isProtectedSharedAuthRequest = req.url.startsWith(environment.userManagementApi.getProfile)
      || req.url.startsWith(environment.userManagementApi.updateProfile);

    if (authToken && (isAuthApiRequest || isProtectedSharedAuthRequest)) {
      const authReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${authToken}`)
      });
      return next.handle(authReq);
    }

    // If no token, proceed with original request
    return next.handle(req);
  }
}
